import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import anime from 'animejs/lib/anime.es.js';

import { AuthService } from 'app/services/auth.service';
import { UserService } from 'app/services/user.service';
import { FlightConnectionsService } from 'app/services/flight-connections-services';

import { FlightOptionCardComponent } from 'app/components/distinct-components/cards/flight-option-card/flight-option-card.component';
import { AvatarComponent } from "app/components/ui-kit/images/avatar/avatar.component";
import { BaseCardComponent } from "app/components/ui-kit/cards/base-card/base-card.component";
import { PrimaryBtnComponent } from 'app/components/ui-kit/buttons/primary-btn/primary-btn.component';
import { SecondaryBtnComponent } from 'app/components/ui-kit/buttons/secondary-btn/secondary-btn.component';
import { SectionLabelComponent } from 'app/components/ui-kit/typography/section-label/section-label.component';

@Component({
  selector: 'app-connection-request',
  standalone: true,
  imports: [AvatarComponent, CommonModule, FlightOptionCardComponent, BaseCardComponent, PrimaryBtnComponent, SecondaryBtnComponent, SectionLabelComponent],
  templateUrl: './connection-request.component.html',
  styleUrl: './connection-request.component.scss'
})
export class ConnectionRequestComponent {
  @Input() request: any;
  @Input() flightOption: any;
  @Input() isAccepting: boolean = false;
  @Input() isDeclining: boolean = false;
  @Output() acceptConnection = new EventEmitter;
  @Output() declineConnection = new EventEmitter;
  
  currentUser: any;
  isLoading: boolean = true;
  fromUser: any;

  constructor(private userService: UserService, private authService: AuthService, private router: Router, private flightConnectionService: FlightConnectionsService) {}

  ngOnInit(): void {
    this.checkUser();
  }

  async checkUser() {
    try {
      const user = await this.authService.getCurrentUser();
      if (user && user.uid === this.request.toId) {
        this.getRequestingUserData();
      } else {
        this.router.navigate(['/agent']);
      }
    } catch (err) {
      console.error('error checking user access') // TODO: Error state
    }
  }

  async getRequestingUserData() {
    try {
      const user = await this.userService.getProfileById(this.request.fromId);
      this.fromUser = user;
    } catch (err) {
      console.error('error loading user', err);
    } finally {
      this.isLoading = false;
      this.markRequestSeen();
      setTimeout(() => {
        this.animateCard();
      }, 100);
    }
  }

  async markRequestSeen() {
    const updates = {
      firstViewedOn: new Date,
      updatedAt: new Date,
    }
    try {
      await this.flightConnectionService.updateConnection(this.request.id, updates);
    } catch (err) {
      // TODO: friendly error
      console.error(err);
    }
  }

  animateCard() {
      anime({
        targets: '#r-card, #request-animate',
        duration: 650,
        opacity: [0, 1],
        translateY: [12, 0],
        delay: anime.stagger(75),
        direction: 'alternate',
        easing: 'spring(1, 80, 10, 2)',
        loop: false,
      });
    }

    onClickAccept() {
      this.acceptConnection.emit();
    }

    onClickDecline() {
      this.declineConnection.emit();
    }
}
